import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import BasicTable from "./BasicTable";

const BasicTableComponent = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Table
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          value={
            'import React from "react";\n' +
            "import {\n" +
            "  Table,\n" +
            "  TableBody,\n" +
            "  TableCell,\n" +
            "  TableContainer,\n" +
            "  TableHead,\n" +
            "  TableRow,\n" +
            '} from "@mui/material";\n' +
            "\n" +
            "const BasicTable = () => {\n" +
            "  return (\n" +
            "    <>\n" +
            "      <TableContainer>\n" +
            "        <Table variant='normal'>\n" +
            "          <TableHead>\n" +
            "            <TableRow>\n" +
            "              <TableCell>type</TableCell>\n" +
            "              <TableCell>cost</TableCell>\n" +
            '              <TableCell align={"center"}>inbound/outbound</TableCell>\n' +
            "              <TableCell>created at</TableCell>\n" +
            "              <TableCell>action</TableCell>\n" +
            "            </TableRow>\n" +
            "          </TableHead>\n" +
            "          <TableBody>\n" +
            "            <TableRow>\n" +
            "              <TableCell>Outgoing Call</TableCell>\n" +
            "              <TableCell>$0.0045</TableCell>\n" +
            '              <TableCell align="center">Out</TableCell>\n' +
            "              <TableCell>today</TableCell>\n" +
            "              <TableCell>send</TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>Outgoing Call</TableCell>\n" +
            "              <TableCell>$0.0045</TableCell>\n" +
            '              <TableCell align="center">Out</TableCell>\n' +
            "              <TableCell>today</TableCell>\n" +
            "              <TableCell>send</TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>Outgoing Call</TableCell>\n" +
            "              <TableCell>$0.0045</TableCell>\n" +
            '              <TableCell align="center">Out</TableCell>\n' +
            "              <TableCell>today</TableCell>\n" +
            "              <TableCell>send</TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>Outgoing Call</TableCell>\n" +
            "              <TableCell>$0.0045</TableCell>\n" +
            '              <TableCell align="center">Out</TableCell>\n' +
            "              <TableCell>today</TableCell>\n" +
            "              <TableCell>send</TableCell>\n" +
            "            </TableRow>\n" +
            "            <TableRow>\n" +
            "              <TableCell>Outgoing Call</TableCell>\n" +
            "              <TableCell>$0.0045</TableCell>\n" +
            '              <TableCell align="center">Out</TableCell>\n' +
            "              <TableCell>today</TableCell>\n" +
            "              <TableCell>send</TableCell>\n" +
            "            </TableRow>\n" +
            "          </TableBody>\n" +
            "        </Table>\n" +
            "      </TableContainer>\n" +
            "    </>\n" +
            "  );\n" +
            "};\n" +
            "\n" +
            "export default BasicTable;\n"
          }
        >
          <BasicTable />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicTableComponent;
